var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcStarBlackFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1175_8475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.92 2.86673C11.03 2.67789 11.1877 2.5212 11.3772 2.4123C11.5667 2.3034 11.7814 2.24609 12 2.24609C12.2186 2.24609 12.4333 2.3034 12.6228 2.4123C12.8123 2.5212 12.97 2.67789 13.08 2.86673L15.875 7.66473L21.303 8.84073C21.5165 8.88713 21.7141 8.98868 21.8762 9.13526C22.0382 9.28185 22.159 9.46834 22.2265 9.67615C22.2939 9.88397 22.3058 10.1058 22.2608 10.3196C22.2158 10.5335 22.1155 10.7317 21.97 10.8947L18.27 15.0357L18.83 20.5607C18.8521 20.7783 18.8167 20.9978 18.7274 21.1974C18.6381 21.3971 18.498 21.5697 18.3211 21.6983C18.1442 21.8268 17.9367 21.9067 17.7192 21.9299C17.5018 21.9532 17.2821 21.919 17.082 21.8307L12 19.5907L6.918 21.8307C6.71792 21.919 6.49819 21.9532 6.28075 21.9299C6.06332 21.9067 5.85578 21.8268 5.67887 21.6983C5.50196 21.5697 5.36186 21.3971 5.27257 21.1974C5.18327 20.9978 5.14791 20.7783 5.17 20.5607L5.73 15.0357L2.03 10.8957C1.88423 10.7328 1.78376 10.5344 1.73861 10.3204C1.69347 10.1065 1.70524 9.88446 1.77274 9.67648C1.84025 9.46851 1.96112 9.28188 2.12331 9.13523C2.28549 8.98857 2.4833 8.88703 2.697 8.84073L8.125 7.66473L10.92 2.86673Z",
    fill: "#314450"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1175_8475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStarBlackFilled);
export default __webpack_public_path__ + "static/media/Ic_Star_Black--filled.d70f9f20612af25aa9b86c5bb3e48f51.svg";
export { ForwardRef as ReactComponent };